module.exports = __webpack_public_path__ + "static/media/bumppyqr.ade4c24e.png";